import historyIcon from '../../../../assets/icons/history.svg';
import * as React from 'react';
import ModalView, { ModalContent } from '../../../../layout/modal/ModalView';
import { COLUMN_SPACING } from '../../../../forms/styles';
import ModalTitleHeader from '../../../../layout/modal/ModalTitleHeader';
import {MediaHistoryModalTable} from './MediaHistoryModalTable';
import { getResource } from '../../../../language/resources/getResource';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../core/redux/IAppState';


type MediaCardHistoryModalProps = {
  guestId: string;
  onDismiss: () => void;
  allowDisableMedia: boolean;
}

/**
 * MediaHistoryModal: a component that shows the media id, RFID, print date, and active or inactive state
 * of each pass that the guest has ever had.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
const MediaHistoryModal: React.FC<MediaCardHistoryModalProps> = (props) => {
  const resources = useSelector((state: IAppState) => state.locale)
  return (
  <ModalView
    size={'1200px'}
    contentCss={COLUMN_SPACING}
    onDismiss={props.onDismiss}
  >
    <ModalTitleHeader resources={resources} heading={getResource(resources, 'MEDIA_HISTORY_MODAL_TITLE')} icon={historyIcon} onDismiss={props.onDismiss} />
    <ModalContent>
      <MediaHistoryModalTable guestId={props.guestId} allowDisableMedia={props.allowDisableMedia} />
    </ModalContent>
  </ModalView>
  )
};

export default MediaHistoryModal;
